export function scrollSection(id){
    document.getElementById(id).scrollIntoView();
}
export function showNotification(title, message, milisecond, bg){
    const date = new Date();
    const time = date.getTime();
    const nt = document.getElementById('notification');
    const tt = document.getElementById('notification-title');
    const mg = document.getElementById('notification-message');
    var background;
    nt.style.display = 'none';
    if(bg){
        background = bg;
    }else{
        background = 'rgb(76, 155, 230)';
    }
    nt.style.background = background;
    nt.setAttribute('time', time);
    setTimeout(function(){
        tt.innerHTML = title;
        mg.innerHTML = message;
        nt.style.display = 'block';
        setTimeout(function(){
            if(nt.getAttribute('time') == time){
                nt.style.display = 'none';
            }
        }, milisecond);
    }, 0);
}
export function optionToggle(button){
    const bt = document.getElementById(button);
    if(bt.nextElementSibling.classList.contains('sso-active')){
        bt.nextElementSibling.classList.remove('sso-active');
        bt.children[2].classList.remove('ssb-icon-active');
    }else{
        bt.nextElementSibling.classList.add('sso-active');
        bt.children[2].classList.add('ssb-icon-active');
    }
}
export function clearWarning(id){
    document.getElementById(id).innerHTML = '';
}
